import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
// import Login from '../views/404.vue' // 武汉版本不要登录页面
import CallBack from '../views/CallBack.vue'

Vue.use(VueRouter)
// 电子现金
const MakeCard = () => import(/* webpackChunkName: "cybercash" */ '../views/cybercash/MakeCard.vue')
const MakeCardCheck = () => import(/* webpackChunkName: "cybercash" */ '../views/cybercash/MakeCardCheck.vue')
const CardCheck = () => import(/* webpackChunkName: "cybercash" */ '../views/cybercash/CardCheck.vue')
const CardTopUp = () => import(/* webpackChunkName: "cybercash" */ '../views/cybercash/CardTopUp.vue')
const BatchCardTopUp = () => import(/* webpackChunkName: "cybercash" */ '../views/cybercash/BatchCardTopUp.vue')
const BatchCardActivation = () => import(/* webpackChunkName: "cybercash" */ '../views/cybercash/BatchCardActivation.vue') // 动态卡批量激活
const DynamiCardRecharge = () => import(/* webpackChunkName: "cybercash" */ '../views/cybercash/DynamiCardRecharge.vue')
const TopUpQuery = () => import(/* webpackChunkName: "cybercash" */ '../views/cybercash/TopUpQuery.vue')
// const BatchActivity = () => import(/* webpackChunkName: "cybercash" */ '../views/cybercash/BatchActivity.vue')
const ExportCard = () => import(/* webpackChunkName: "cybercash" */ '../views/cybercash/ExportCard.vue')
const StorageCardStore = () => import(/* webpackChunkName: 'cybercash' */ '../views/cybercash/StorageCardStore/StorageCardStore.vue')
const StorageCardExam = () => import(/* webpackChunkName: 'cybercash' */ '../views/cybercash/StorageCardExam.vue')
const StorageCardSale = () => import(/* webpackChunkName: 'cybercash' */ '../views/cybercash/StorageCardSale/StorageCardSale.vue')
const RefundApply = () => import(/* webpackChunkName: 'cybercash' */ '../views/cybercash/RefundApply.vue')
const RefundAudit = () => import(/* webpackChunkName: 'cybercash' */ '../views/cybercash/RefundAudit.vue')

// 服务台
const CardInfo = () => import(/* webpackChunkName: "serviceDesk" */ '../views/serviceDesk/CardInfo.vue')

// 数据
const WriteOffSum = () => import(/* webpackChunkName: "dataFile" */ '../views/dataFile/WriteOffSum.vue')
const WriteOffInfo = () => import(/* webpackChunkName: "dataFile" */ '../views/dataFile/WriteOffInfo.vue')
const PoundageSum = () => import(/* webpackChunkName: "dataFile" */ '../views/dataFile/PoundageSum.vue')
const PoundageInfo = () => import(/* webpackChunkName: "dataFile" */ '../views/dataFile/PoundageInfo.vue')
const SellCard = () => import(/* webpackChunkName: "dataFile" */ '../views/dataFile/SellCard.vue')
const MonitorView = () => import(/* webpackChunkName: "dataFile" */ '../views/dataFile/MonitorView.vue') // 风控监测视图
const CardBindingRecord = () => import(/* webpackChunkName: "dataFile" */ '../views/dataFile/CardBindingRecord.vue') // 绑卡记录
const CardTransfer = () => import(/* webpackChunkName: "dataFile" */ '../views/dataFile/CardTransfer.vue')
const RefundDetail = () => import(/* webpackChunkName: "dataFile" */ '../views/dataFile/RefundDetail.vue')

// 任务
const TaskList = () => import(/* webpackChunkName: "cybercash" */ '../views/task/TaskList.vue')

// 设置
const CardType = () => import(/* webpackChunkName: "setting" */ '../views/setting/CardType.vue')
const PoundageSet = () => import(/* webpackChunkName: "setting" */ '../views/setting/PoundageSet.vue')
const User = () => import(/* webpackChunkName: "setting" */ '../views/setting/User.vue')
const Role = () => import(/* webpackChunkName: "setting" */ '../views/setting/Role.vue')
const HandleRole = () => import(/* webpackChunkName: "setting" */ '../views/setting/HandleRole.vue')
const SaleCardPriceSet = () => import(/* webpackChunkName: "setting" */ '../views/setting/SaleCardPriceSet.vue')
const Rule = () => import(/* webpackChunkName: "setting" */ '../views/setting/Rule.vue')


const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/CallBack',
    component: CallBack
  }
]

export const asyncRoutes = [
  {
    path: '/cybercash',
    component: Home,
    name: '智慧卡',
    children: [{
      path: 'makeCard',
      meta: { title: '制卡管理' },
      component: MakeCard
    },
    {
      path: 'makeCardCheck',
      meta: { title: '制卡审核' },
      component: MakeCardCheck
    }, {
      path: 'cardCheck',
      meta: { title: '卡管理' },
      component: CardCheck
    }, {
      path: 'cardTopUp',
      meta: { title: '动态卡充值' },
      component: CardTopUp
    }, {
      path: 'batchCardTopUp',
      meta: { title: '动态卡批量充值' },
      component: BatchCardTopUp
    }, {
      path: 'batchCardActivation',
      meta: { title: '动态卡批量激活' },
      component: BatchCardActivation
    }, {
      path: 'topUpQuery',
      meta: { title: '充值管理' },
      component: TopUpQuery
    }, 
    // {
    //   path: 'batchActivity',
    //   meta: { title: '批量激活' },
    //   component: BatchActivity
    // },
    {
      path: 'ExportCard',
      meta: { title: '导出制卡' },
      component: ExportCard
    }, {
      path: 'dynamiCardRecharge',
      meta: { title: '动态卡充值确认' },
      component: DynamiCardRecharge
    },{
      path: 'storageCardStore',
      meta: { title: '储值卡入库' },
      component: StorageCardStore
    },{
      path: 'storageCardExam',
      meta: { title: '储值卡入库审核' },
      component: StorageCardExam
    },{
      path: 'storageCardSale',
      meta: { title: '储值卡售卡' },
      component: StorageCardSale
    },{
      path: 'refundApply',
      meta: { title: '储值卡退卡' },
      component: RefundApply
    },{
      path: 'refundAudit',
      meta: { title: '预付卡退卡审核' },
      component: RefundAudit
    }]
  },
  {
    path: '/serviceDesk',
    component: Home,
    name: '服务台',
    children: [{
      path: 'cardInfo',
      meta: { title: '信息查询' },
      component: CardInfo
    }]
  },
  {
    path: '/dataFile',
    component: Home,
    name: '数据',
    children: [{
      path: 'writeOffSum',
      meta: { title: '核销汇总' },
      component: WriteOffSum
    },
    {
      path: 'writeOffInfo',
      meta: { title: '核销明细' },
      component: WriteOffInfo
    },
    {
      path: 'poundageSum',
      meta: { title: '店铺手续费汇总' },
      component: PoundageSum
    },
    {
      path: 'poundageInfo',
      meta: { title: '店铺手续费明细' },
      component: PoundageInfo
    }, {
      path: 'sellCard',
      meta: { title: '售卡统计' },
      component: SellCard
    }, {
      path: 'monitorView',
      meta: { title: '风控监测视图' },
      component: MonitorView
    }, {
      path: 'cardBindingRecord',
      meta: { title: '绑卡记录' },
      component: CardBindingRecord
    }, {
      path: 'cardTransfer',
      meta: { title: '卡转增记录' },
      component: CardTransfer
    }, {
      path: 'refundDetail',
      meta: { title: '退卡记录' },
      component: RefundDetail
    }]
  },
  {
    path: '/task',
    component: Home,
    name: '任务',
    children: [{
      path: 'taskList',
      meta: { title: '任务管理' },
      component: TaskList
    }]
  },
  {
    path: '/setting',
    component: Home,
    name: '设置',
    children: [{
      path: 'cardType',
      meta: { title: '卡类型' },
      component: CardType
    }, {
      path: 'poundageSet',
      meta: { title: '手续费设置' },
      component: PoundageSet
    }, {
      path: 'user',
      meta: { title: '用户管理' },
      component: User
    }, {
      path: 'handleRole',
      meta: { title: '角色管理' },
      component: HandleRole
    }, {
      path: 'role',
      meta: { title: '角色管理' },
      component: Role
    },{
      path: 'priceSet',
      meta: { title: '售卖调整价设置' },
      component: SaleCardPriceSet
    },{
      path: 'rule',
      meta: { title: '卡规则设置' },
      component: Rule
    }]
  }
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
const createRouter = () => new VueRouter({
  routes
})

const router = createRouter()

export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // the relevant part
}


router.beforeEach((to, from, next) => {
  if (to.path !== "/login" && to.path !== '/CallBack') {
    const userInfo = localStorage.getItem('userInfo')
    const token = JSON.parse(userInfo) && JSON.parse(userInfo).token
    if (token) {
      next();
    } else {
      if (window.self !== window.top) {
        window.top.postMessage('reloadPortal', '*')
      } else {
        next('/login');
      }
    }
  } else {
    localStorage.clear();
    next();
  }
});

export default router
